import Auth from "./components/AuthComponent";
import Admin from "./components/AdminComponent";

import Wrapper from "./pages/Wrapper";

import Login from "./pages/auth/Login";
import Register from "./pages/auth/Register";
import Forgot from "./pages/auth/Forgot";
import Reset from "./pages/auth/Reset";

import Terms from "./pages/Terms";

import Home from "./pages/Home";
import Notifications from "./pages/Notifications";
import Request from "./pages/Request";
import Voucher from "./pages/request/Voucher";
import Receivers from "./pages/Receivers";
import History from "./pages/History";
import Show from "./pages/Show";
import Corrections from "./pages/Corrections";
import Claim from "./pages/Claim";
import Claims from "./pages/Claims";
import ClaimView from "./pages/ClaimView";
import Calculator from "./pages/Calculator";
import Offices from "./pages/Offices";
import WalletRecharge from "./pages/wallet/Recharge";
import WalletReceive from "./pages/wallet/Receive";
import WalletPay from "./pages/wallet/Pay";
import WalletWithdraw from "./pages/wallet/Withdraw";
import UserAccounts from './pages/Accounts';
import About from "./pages/About";
import Rewards from "./pages/Rewards";
import Legal from "./pages/Legal";
import Profile from "./pages/Profile";
import ProfileView from "./pages/ProfileView";
import Settings from "./pages/Settings";
import NotFound from "./pages/404";

import VPending from "./pages/admin/checker/Pending";
import VApproved from "./pages/admin/checker/Approved";
import VRejected from "./pages/admin/checker/Rejected";
import VCorrections from "./pages/admin/checker/Corrections";

import TPending from "./pages/admin/payer/Pending";
import TApproved from "./pages/admin/payer/Approved";
import TCorrections from "./pages/admin/payer/Corrections";

import CPending from "./pages/admin/claims/Pending";
import CResponded from "./pages/admin/claims/Responded";
import CClosed from "./pages/admin/claims/Closed";

import Collect from "./pages/admin/cashier/Collect";
import InOut from "./pages/admin/cashier/InOut";
import Exchange from "./pages/admin/cashier/Exchange";
import CsPending from "./pages/admin/cashier/Pending";
import Balance from "./pages/admin/cashier/Balance";
import Movements from "./pages/admin/cashier/Movements";
import WalletWithdrawals from "./pages/admin/wallet/Withdrawals";
import CustomerBankAccounts from "./pages/admin/wallet/BankAccounts";
import CryptoTransfers from "./pages/admin/wallet/CryptoTransfers";

import Participants from "./pages/admin/lottery/Participants";
import Conditions from "./pages/admin/lottery/Conditions";
import Winners from "./pages/admin/lottery/Winners";

import Accounts from "./pages/admin/accounting/Accounts";
import BankMovements from "./pages/admin/accounting/Movements";
import BankTransfer from "./pages/admin/accounting/Transfer";
import AcInOut from "./pages/admin/accounting/InOut";

import General from "./pages/admin/auditor/General";
import Completed from "./pages/admin/auditor/Completed";
import ReportOffices from "./pages/admin/auditor/Offices";
import ReportAttendance from "./pages/admin/auditor/Attendance";
import CustomersOnline from "./pages/admin/auditor/CustomersOnline";

import Customers from "./pages/admin/settings/Customers";
import CustomerHistory from "./pages/admin/settings/CustomerHistory";
import Staff from "./pages/admin/settings/Staff";

import configAds from "./pages/admin/settings/Ads";
import configLegal from "./pages/admin/settings/Legal";
import configRate from "./pages/admin/settings/Rate";
import configGateways from "./pages/admin/settings/Gateways";
import configAccounts from "./pages/admin/settings/Accounts";
import configOffices from "./pages/admin/settings/Offices";
import configLimits from "./pages/admin/settings/Limits";
import configCurrencies from "./pages/admin/settings/Currencies";
import configIdentity from "./pages/admin/settings/Identity";
import configNotifications from "./pages/admin/settings/Notifications";
import configAppVersion from "./pages/admin/settings/AppVersion";
import configRewards from "./pages/admin/settings/Rewards";
import configCustody from "./pages/admin/settings/Custody";
import configFee from "./pages/admin/settings/Fee";

export default [
    ...applyRules(['guest'], [
        { path: '', component: Auth, redirect: { name: 'Login' }, children:
            [
                { path: '/login', name: 'Login', component: Login, meta: { title: 'Inicio' } },
                { path: '/register', name: 'Register', component: Register, meta: { title: 'Crear Cuenta' } },
                { path: '/password', component: Wrapper, children:
                    [
                        { path: 'reset', name: 'Forgot', component: Forgot, meta: { title: 'Recuperar Contraseña' } },
                        { path: 'reset/:token', name: 'Reset', component: Reset, meta: { title: 'Cambiar Contraseña' } }
                    ]
                },
                { path: '/calculate', name: 'Calculate', component: Calculator, meta: { title: 'Calculadora' } },
            ]
        },
    ]),
    ...applyRules(['auth'], [
        { path: '', component: Admin, redirect: { name: 'Home' }, children:
            [
                { path: '/', name: 'Home', component: Home, meta: { title: 'Inicio' } },
                { path: '/notifications', name: 'Notifications', component: Notifications, meta: { title: 'Mis Notificaciones' } },
                { path: '/request', name: 'Request', component: Request, meta: { title: 'Crear Pago' } },

                { path: '/request/result', name: 'Result', component: Voucher, meta: { title: 'Resumen de Pago' } },

                { path: '/history', name: 'History', component: History, meta: { title: 'Mi Historial' } },
                { path: '/history/payment/:id', name: 'PaymentVoucher', component: Voucher, meta: { title: 'Detalles de Pago' } },
                { path: '/history/transfer/:id', name: 'TransferVoucher', component: Show, meta: { title: 'Detalles de Giro' } },
                { path: '/calculator', name: 'Calculator', component: Calculator, meta: { title: 'Calculadora' } },
                { path: '/favorites', name: 'Receivers', component: Receivers, meta: { title: 'Mis Favoritos' } },
                { path: '/offices', name: 'Offices', component: Offices, meta: { title: 'Oficinas' } },
                { path: '/wallet/recharge', name: 'WalletRecharge', component: WalletRecharge, meta: { title: 'Recargar Wallet' } },
                { path: '/wallet/receive', name: 'WalletReceive', component: WalletReceive, meta: { title: 'Recibir Wallet' } },
                { path: '/wallet/pay', name: 'WalletPay', component: WalletPay, meta: { title: 'Pagar Wallet' } },
                { path: '/wallet/withdraw', name: 'WalletWithdraw', component: WalletWithdraw, meta: { title: 'Retirar Wallet' } },

                { path: '/user', name: 'ProfileView', component: ProfileView, meta: { title: 'Mi Perfil' } },
                { path: '/user/edit', name: 'Profile', component: Profile, meta: { title: 'Editar Perfil' } },
                { path: '/user/settings', name: 'Settings', component: Settings, meta: { title: 'Configuración y Seguridad' } },
                { path: '/user/password', name: 'Password', redirect: { name: 'Settings' }, meta: { title: 'Configuración y Seguridad' } },
                { path: '/user/accounts', name: 'Accounts', component: UserAccounts, meta: { title: 'Mis Cuentas Bancarias' } },
                { path: '/user/corrections', name: 'Corrections', component: Corrections, meta: { title: 'Mis Correcciones Pendientes' } },
                { path: '/user/about', name: 'About', component: About, meta: { title: 'Información' } },
                { path: '/user/rewards', name: 'Rewards', component: Rewards, meta: { title: 'Mis Recompensas' } },
                { path: '/user/support', name: 'Claims', component: Claims, meta: { title: 'Mis Tickets de Soporte' } },
                { path: '/user/support/new', name: 'Claim', component: Claim, meta: { title: 'Crear Ticket' } },
                { path: '/user/support/:id', name: 'ClaimView', component: ClaimView, meta: { title: 'Detalles del Ticket' } },
                { path: '/user/legal', name: 'TermsView', component: Legal, meta: { title: 'Términos & Condiciones' } },

                { path: '/checker/pending', name: 'VPending', component: VPending, meta: { title: 'Pendientes' } },
                { path: '/checker/approved', name: 'VApproved', component: VApproved, meta: { title: 'Aprobadas' } },
                { path: '/checker/rejected', name: 'VRejected', component: VRejected, meta: { title: 'Rechazadas' } },
                { path: '/checker/corrections', name: 'VCorrections', component: VCorrections, meta: { title: 'Correcciones Pendientes' } },

                { path: '/payer/pending', name: 'TPending', component: TPending, meta: { title: 'Pendientes' } },
                { path: '/payer/approved', name: 'TApproved', component: TApproved, meta: { title: 'Realizadas' } },
                { path: '/payer/corrections', name: 'TCorrections', component: TCorrections, meta: { title: 'Correcciones Pendientes' } },

                { path: '/claims/pending', name: 'CPending', component: CPending, meta: { title: 'Tickets Por Responder' } },
                { path: '/claims/responded', name: 'CResponded', component: CResponded, meta: { title: 'Tickets Respondidos' } },
                { path: '/claims/closed', name: 'CClosed', component: CClosed, meta: { title: 'Tickets Cerrados' } },
                { path: '/claims/v/:id', name: 'ClaimViewAdmin', component: ClaimView, meta: { title: 'Detalles del Ticket' } },

                { path: '/lottery/participants', name: 'Participants', component: Participants, meta: { title: 'Participantes' } },
                { path: '/lottery/conditions', name: 'Conditions', component: Conditions, meta: { title: 'Coondiciones' } },
                { path: '/lottery/winners', name: 'Winners', component: Winners, meta: { title: 'Ganadores' } },

                { path: '/cashier/in', name: 'Collect', component: Collect, meta: { title: 'Pendientes por Cobrar' } },
                { path: '/cashier/out', name: 'CsPending', component: CsPending, meta: { title: 'Pagos Pendientes' } },
                { path: '/cashier/in-out', name: 'InOut', component: InOut, meta: { title: 'Entradas/Salidas' } },
                { path: '/cashier/exchange', name: 'Exchange', component: Exchange, meta: { title: 'Cambio de Divisas' } },
                { path: '/cashier/balance', name: 'Balance', component: Balance, meta: { title: 'Balance Actual' } },
                { path: '/cashier/movements', name: 'Movements', component: Movements, meta: { title: 'Movimientos' } },
                { path: '/payer/wallet-withdrawals', name: 'WalletWithdrawals', component: WalletWithdrawals, meta: { title: 'Retiros Wallet' } },
                { path: '/payer/crypto-transfers', name: 'PayerCryptoTransfers', component: CryptoTransfers, meta: { title: 'Transacciones On-chain' } },
                { path: '/wallet/crypto-transfers', name: 'CryptoTransfers', component: CryptoTransfers, meta: { title: 'Transacciones On-chain' } },

                { path: '/movements/accounts', name: 'Accounts', component: Accounts, meta: { title: 'Cuentas Bancarias' } },
                { path: '/movements/accounts/:id', name: 'BankMovements', component: BankMovements, meta: { title: 'Movimientos Bancarios' } },
                { path: '/movements/transfer', name: 'BankTransfer', component: BankTransfer, meta: { title: 'Traslados' } },
                { path: '/movements/in-out', name: 'AcInOut', component: AcInOut, meta: { title: 'Entradas/Salidas' } },

                { path: '/reports/general', name: 'General', component: General, meta: { title: 'Reporte General' } },
                { path: '/reports/completed', name: 'Completed', component: Completed, meta: { title: 'Reporte Completadas' } },
                { path: '/reports/offices', name: 'ReportOffices', component: ReportOffices, meta: { title: 'Reporte de Oficinas' } },
                { path: '/reports/attendance', name: 'ReportAttendance', component: ReportAttendance, meta: { title: 'Reporte de Asistencia' } },
                { path: '/reports/customers-online', name: 'CustomersOnline', component: CustomersOnline, meta: { title: 'Clientes en Linea' } },

                { path: '/users/customers', name: 'Customers', component: Customers, meta: { title: 'Listado de Clientes' } },
                { path: '/users/bank-accounts', name: 'CustomerBankAccounts', component: CustomerBankAccounts, meta: { title: 'Cuentas Bancarias Clientes' } },
                { path: '/users/customers/history/:id', name: 'CustomerHistory', component: CustomerHistory, meta: { title: 'Historial del Cliente' } },
                { path: '/users/staff', name: 'Staff', component: Staff, meta: { title: 'Listado de Empleados' } },

                { path: '/settings/ads', name: 'configAds', component: configAds, meta: { title: 'Configurar Anuncios' } },
                { path: '/settings/legal', name: 'configLegal', component: configLegal, meta: { title: 'Configurar Información Legal' } },
                { path: '/settings/rate', name: 'configRate', component: configRate, meta: { title: 'Configurar Tasa de Cambio' } },
                { path: '/settings/gateways', name: 'configGateways', component: configGateways, meta: { title: 'Registro de Bancos' } },
                { path: '/settings/accounts', name: 'configAccounts', component: configAccounts, meta: { title: 'Registro de Cuentas' } },
                { path: '/settings/offices', name: 'configOffices', component: configOffices, meta: { title: 'Registro de Oficinas' } },
                { path: '/settings/limits', name: 'configLimits', component: configLimits, meta: { title: 'Configurar Montos Minimos' } },
                { path: '/settings/currencies', name: 'configCurrencies', component: configCurrencies, meta: { title: 'Configurar Monedas' } },
                { path: '/settings/identity', name: 'configIdentity', component: configIdentity, meta: { title: 'Configurar Identidad' } },
                { path: '/settings/notifications', name: 'configNotifications', component: configNotifications, meta: { title: 'Configurar Notificaciones' } },
                { path: '/settings/app-version', name: 'configAppVersion', component: configAppVersion, meta: { title: 'Configurar Versiones App' } },
                { path: '/settings/rewards', name: 'configRewards', component: configRewards, meta: { title: 'Configurar Recompensas' } },
                { path: '/settings/custody', name: 'configCustody', component: configCustody, meta: { title: 'Configurar Billeteras Blockchain' } },
                { path: '/settings/fee', name: 'configFee', component: configFee, meta: { title: 'Configurar Comisiones' } },
            ]
        }
    ]),
    { path: '', component: Auth, redirect: {name: 'Login'}, children:
        [
            { path: '/terms', name: 'Terms', component: Terms, meta: { title: 'Términos & Condiciones' } }
        ]
    },
    { path: '', component: Wrapper, redirect: {name: 'Login'}, children:
            [
                { path: '/calculator/public', name: 'CalculatorPublic', component: Calculator, meta: { title: 'Calculadora' } },
            ]
    },
    { path: '/m', redirect: { name: 'Home' }, meta: { title: 'Inicio' } },
    { path: '*', component: NotFound, meta: { title: 'Página no Encontrada' } }
];

function applyRules(rules, routes) {
    return routes.map(route => {
        const newRoute = { ...route };

        // Clonar meta
        newRoute.meta = { ...(route.meta || {}) };

        const existingRules = newRoute.meta.rules || [];

        // 🔥 Sin duplicados
        newRoute.meta.rules = [...rules, ...existingRules].filter(
            (rule, index, self) =>
                index === self.findIndex(r => JSON.stringify(r) === JSON.stringify(rule))
        );

        // Recursivo
        if (route.children) {
            newRoute.children = applyRules(rules, route.children);
        }

        return newRoute;
    });
}
